export const LeaderboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5234 2C16.7739 2 17.1753 2.10156 17.4258 2.20312L27.0439 6.26562C27.9457 6.67188 28.5471 7.53516 28.4971 8.5C28.4971 21.449 19.0289 27.9997 16.4736 28C13.9687 28 4.5 21.5507 4.5 8.5C4.5 7.53516 5.05136 6.67188 5.95312 6.26562L15.5713 2.20312C15.8217 2.10158 16.2229 2.00003 16.5234 2ZM14.1797 10C13.3687 10.0254 12.828 12.2373 12.7051 13.3926C12.6068 13.6383 12.5329 13.9333 12.4346 14.2773C12.2871 14.8428 12.0904 15.5071 11.7217 16.3184C11.5988 16.5887 11.5246 16.8343 11.5 17.0801V17.2031C11.4508 19.4649 15.4338 20.0058 16.5156 20.0059C17.5973 20.0059 21.8261 19.3909 21.5557 17.1045C21.5065 16.8833 21.4326 16.6375 21.2852 16.3672C20.8918 15.6297 20.7198 14.9902 20.5723 14.4248C20.4985 14.1053 20.4001 13.7859 20.3018 13.5156C20.2034 12.3847 19.662 10.0488 18.8262 10.0488C18.4327 10.0494 17.6956 10.787 17.2041 11.6963C16.7616 11.6717 16.2941 11.6471 15.8516 11.6963C15.3599 10.7869 14.6474 10.0744 14.2295 10.0742L14.1797 10Z"
      fill="currentColor"
    />
    <path
      d="M9.9849 25.9497L6.44937 29.4853L5.03516 25.9497L1.49962 24.5355L5.03516 21L7.51003 23.4749L9.9849 25.9497Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M27.9341 20.9995L31.4697 24.535L27.9341 25.9492L26.5199 29.4848L22.9844 25.9492L25.4592 23.4743L27.9341 20.9995Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
